import axios from "axios";
import {getUserExperimentId} from "./ExpirmentHelper";

const API_URL = process.env.REACT_APP_API_BASE_URL
const SETUP_API_URL = API_URL + "/setup"
const AUTH_API_URL = API_URL + "/auth"
const STRIPE_API_URL = API_URL + "/stripe"
const TOOLS_API_URL = API_URL + "/tools"
const SERVICES_API_URL = API_URL + "/services"

//------------- SETUP CALLS -----------------
export async function getLandingPage() {
    try {
        const userExperimentId = getUserExperimentId()
        const response = await axios.post(`${SETUP_API_URL}/landing-page/`, {userExperimentId});
        return response.data
    } catch (error) {
        console.error("Error fetching landing page:", error);
    }
}

//---------------- END --------------------


//------------- AUTH CALLS -----------------
export async function isUserPremium(userId: string) {
    try {
        const response = await axios.post(`${AUTH_API_URL}/get-user-info/`, {userId});
        return response.data
    } catch (error) {
        console.error("Error fetching isUserPremium:", error);
    }
}

export async function notifyUserEmailEntered(email: string, userExperimentId: string) {
    try {
        const response = await axios.post(`${AUTH_API_URL}/user-email-entered/`, {
            email: email,
            userExperimentId: userExperimentId
        });
        return response.data;
    } catch (error) {
        console.error("Error notifying user email entered:", error);
        // Don't throw error to prevent signup failure if this API call fails
        return { beehiiv_added: false };
    }
}

// export async function updateItemCompleted(type: string, id: string, userId: string, hasCompleted: boolean) {
//     try {
//         return await axios.post(`${AUTH_API_URL}/update-completion/`, {type: type, id: id, userId: userId, hasCompleted: hasCompleted});
//     } catch (error) {
//         console.error("Error validating coupon:", error);
//     }
// }
//---------------- END --------------------


//------------- STRIPE CALLS -----------------
export async function getPricingOptions() {
    try {
        return await axios.get(`${STRIPE_API_URL}/pricing-options/`);
    } catch (error) {
        console.error("Error fetching prices:", error);
    }
}

export async function validateCoupon(code: String) {
    try {
        return await axios.post(`${STRIPE_API_URL}/validate-coupon/`, {code});
    } catch (error) {
        console.error("Error validating coupon:", error);
    }
}

export async function createNewCheckoutSession(coupon: string, successUrl: string, cancelUrl: string, uid: string, email: string, stripePriceId: string) {
    try {
        return await axios.post(`${STRIPE_API_URL}/create-checkout-session/`, {
            coupon: coupon,
            successUrl: successUrl,
            cancelUrl: cancelUrl,
            uid: uid,
            email: email,
            stripePriceId: stripePriceId
        });
    } catch (error) {
        console.error("Error creating checkout session:", error);
    }
}
//---------------- END --------------------

//------------- TOOLS CALLS -----------------
export async function analyzeUserResume(file: File) {
    try {
        const formData = new FormData();
        formData.append('resume', file);
        const response = await axios.post(`${TOOLS_API_URL}/analyze-resume/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error uploading resume:", error);
    }
}

export async function generateInterviewQuestions(file: File, jobDescription: string) {
    try {
        const formData = new FormData();
        formData.append('resume', file);
        formData.append('jobDescription', jobDescription);
        const response = await axios.post(`${TOOLS_API_URL}/generate-interview-questions/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error generating interview questions:", error);
    }
}
//---------------- END --------------------

//------------- SERVICES CALLS -----------------
export async function sendEmail(to: string, subject: string, html: string, text: string) {
    try {
        const response = await axios.post(`${SERVICES_API_URL}/send-email/`, {
            to: to,
            subject: subject,
            html: html,
            text: text
        });
        return response.data;
    } catch (error) {
        console.error("Error sending email:", error);
        throw error;
    }
}
//---------------- END --------------------